import { capitalize } from 'lodash';
import { ProductIDOptions } from 'src/utils/stripeConfig';
import { callApi } from 'src/core/callApi';

export const getUserSubscriptionDetails = async (email: string, adminPassword: string, setUserSubscriptionDetails, setUserCurrentSubscriptionDetailsError, extraParamsToFetchHistory = {}) => {
  const URL =
    'https://w2g9kh7lf4.execute-api.us-east-2.amazonaws.com/default/fetchCustomerSubscriptionDetails';

  const userDetails = await callApi(
    URL,
    {
      queryParams: {
        // isTest: true,
        adminRequestedEmail: email,
        adminPassword: adminPassword,
        ...extraParamsToFetchHistory,
      },
    },
    true,
    false,
    '',
    'GET',
    true
  );

  console.log(userDetails);

  if (userDetails.subscriptions) {
    userDetails &&
      !userDetails.error &&
      userDetails.subscriptions &&
      userDetails.subscriptions.length > 0 &&
      setUserSubscriptionDetails(userDetails.subscriptions);
  } else {
    userDetails && !userDetails.error && setUserSubscriptionDetails(userDetails);
  }

  userDetails && userDetails.error && setUserCurrentSubscriptionDetailsError("You don't have any subscriptions.");
};


export const getUserSubscriptionHistory = async (email: string, adminPassword: string, setUserSubscriptionHistory, setUserSubscriptionHistoryError, refresh = false) => {
  const extraParamsToFetchHistory = {
    fetchSubscriptionHistory: true,
    refreshData: refresh,
  };
  getUserSubscriptionDetails(email, adminPassword, setUserSubscriptionHistory, setUserSubscriptionHistoryError, extraParamsToFetchHistory);
}


export const getPlanLabelFromPriceID = (priceID: string) => {
  const planEntries = Object.entries(ProductIDOptions);

  for (const [planKey, { productID }] of planEntries) {
    const matchedInterval = Object.entries(productID).find(
      ([, id]) => id === priceID
    );

    if (matchedInterval) {
      const [interval] = matchedInterval;
      const capitalizedPlan = capitalize(planKey);
      const capitalizedInterval = capitalize(interval);
      return ({
        text: `${capitalizedPlan} – ${capitalizedInterval}`,
        planKey: planKey,
        interval: interval,
      });
    }
  }

  return {
    text: priceID,
    planKey: null,
    interval: null,
  };
};

export const getPlanDurationFrequency = (activeSubscriptionDetails) => {
  if(!activeSubscriptionDetails.length) return null;
  activeSubscriptionDetails = activeSubscriptionDetails[activeSubscriptionDetails.length - 1];
  const startDatesArray = activeSubscriptionDetails.start_date;
  const endDatesArray = activeSubscriptionDetails.end_date;

  // Format: YYYY-MM-DD string
  const latestStartDate = startDatesArray[startDatesArray.length - 1];
  const latestEndDate = endDatesArray[endDatesArray.length - 1];

  const duration = new Date(latestEndDate).getTime() - new Date(latestStartDate).getTime();
  const durationInDays = Math.ceil(duration / (1000 * 60 * 60 * 24));

  console.log("DAY DAY DAY:", durationInDays);

  const frequency = durationInDays < 365 ? 'month' : 'year';

  return frequency;
}


export const clearRateLimits = async (email: string, adminPassword: string) => {
  const URL = 'https://v2moz5pks1.execute-api.us-east-2.amazonaws.com/prod/rateLimitActionsByAdmin';
  const response = await callApi(URL, {
    queryParams: {
      email: encodeURIComponent(email),
      adminPassword: encodeURIComponent(adminPassword),
      action: "clear_all_rate_limit_actions"
    },
  }, true, false, '', 'GET', true);

  return response;
}